const Form014TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInfo: "申請資料",
        confirmation: "確認",
    },
    label: {
        title: {
            tips: "申請向教師發還課程費用",
            tipsA: "學校資料",
        },
        selection: {
            schoolHead: "校長",
            teacher: "教師",
        },
        schoolHeadOption: {
            supervisor: "校監",
            schoolHead: "校長",
        },
        nameOfApplicant: "申請人姓名",
        courseTitle: "課程名稱",
        courseDuration: "課程日期",
        courseStartDate: "課程開始日期",
        courseEndDate: "課程結束日期",
        courseFee: "課程費用",
        refundAmountA: "建議發還的課程費用金額",
        refundAmountB: "經批核發還的課程費用金額（只供教育局人員填寫）",
        refundAmountATotal: "建議發還的課程費用總金額",
        name: "審批人姓名（校監／校長）",
        schoolRegistrationName: "學校註冊名稱",
        schoolRegistrationNo: "學校註冊編號",
        accountPayee: "支票抬頭名稱（僅限學校帳戶）",
        schoolRegistrationAddress: "學校註冊地址",
        schoolEmailAddress: "學校電郵地址",
        telephoneNo: "電話號碼",
        faxNo: "傳真號碼",
        schoolHeadOrTeacher: "本申請的申請人包括",
        supervisorOrschoolHead: "審批人（向教育局簽署及提交此申請的人）",
        supportDoc: "證明文件",
        pisc: "個人資料收集聲明",
        declarationText: "聲明（待審批人確認）",
        declarationTextApprover1: "聲明（",
        declarationTextApprover2:
            "請閲讀以下聲明。一經簽署並提交本申請，即表示您作爲審批人已作出下列聲明。",
        note: {
            note1: "本人為申請人所任職學校的<b>{{positionOne}}</b>，現簽署以確認上述<b>{{positionTwo}}</b>已完成課程，並符合<b>{{dateTime}}</b>發出的教育局通函<b>{{clauseText}}</b>所載的要求。上述<b>{{positionTwo}}</b>從未就同一項課程獲得公帑資助。本校會妥善保存由課程機構所發出的",
            note1A: "正式收據正本，以及成績單、證書及相關文件的副本，",
            note1B: "以供教育局隨時審閱。",
            note2: "總額（不多於港幣{{totalAmount}}元）",
            note3: "發還課程費用的安排只適用於在{{note1Start}}至{{note1End}}期間完成的課程。",
        },
        importNotesList: {
            oneText:
                "請細閱教育局通函{{clauseText}}「向教師發還課程費用」，以了解申請程序及要求。",
            twoText:
                "當校長／教師完成有關課程後，請其校監／校長於<b>{{periodText}}</b>期間遞交申請， 為有關校長／教師申請發還課程費用。<b>逾期申請概不受理</b>。",
            threeText:
                "學校須妥善記錄及保存有關校長／教師曾修讀的課程資料，包括正式收據正本，以及成績單、證書及相關文件的副本，以供教育局隨時審閱。",
            fourText:
                "如校監／校長作為審批人有已啟用數碼簽署功能的「智方便+」帳戶，他／她可直接透過此電子平台向教育局遞交申請。否則，校監／校長需要下載和簽署已填妥的申請表格，並以傳真或郵寄方式將申請表格遞交至教育局培訓小組。",
        },
        refundRemark:
            "如有11位或更多的申請者申請發還課程費用，您可以表列及上載有關申請的資料（包括申請者姓名、課程名稱、課程日期、課程費用、建議發還的課程費用金額和建議發還的課程費用總金額），並以Excel／Word文件格式上載為補充文件予教育局作審批。",
    },
    label1: {
        header: {
            headerOne: "聲明",
        },
        statement: "本人已閱讀及明白上述重要提示及個人資料收集聲明",
        statement2:
            "我理解審批人需要擁有「智方便+」帳戶才能直接透過此電子平台向教育局遞交申請",
    },

    errorMsg: {
        // required: "此字段必填",
        email: "請輸入正確的電郵地址",
        courseRefund: "此項不可多於港幣{{amount}}元",
        lessCourseFee: "建議發還的課程費用金額不能超過課程費用",
        numLimit: "請輸入{{limit}}",
        numLimit2: "總額不多於{{limit}}",
        number: "請輸入正確格式的編號",
        checkIsRequired: "請閱讀上述重要提示及個人資料收集聲明，並勾選此選項",
        checkRead: "請閱讀上述重要提示，並勾選此選項",
        minDigit: "此項最少需要填寫{{min}}個數字",
        checkSchoolHead: "如校長申請發還課程費用，此表格須由校監簽署",
        checkApproverRole: "請參照上述已選擇的職位，選擇對應的審批人",
        length: {
            note: "長度不得超過50個字符",
            note1: "長度不得超過100個字符",
            note2: "長度不得超過200個字符",
            note3: "長度不得超過1000個字符",
        },
        tel: {
            rule: "請輸入一個有效的8位電話號碼",
            digit: "必須為8位電話號碼",
        },
        fax: {
            rule: "請輸入一個有效的8位傳真號碼",
            digit: "必須為8位傳真號碼",
        },
        date: {
            rule: "請輸入有效日期",
            todayOrBefore: "請選擇今天或之前",
            afterThisDate: "請在之後選擇日期{{targetDate}}",
            age: "申請人在提交時至少年滿18歲。",
        },
    },
};
export default Form014TC;
